/**
 * fusionFounderAccountingRoutes.jsx — Fusion Founder ledger path.
 * Shaped by prompt 35; MKT-05.
 * Invariants: alias/redirect only; gate unchanged. The stored tier value stays
 * `founding`. The old /dashboard/founding-partner/accounting path redirects here.
 * Related: AdminRoutes.jsx, FoundingPartnerAccountingGate.jsx
 */
import React from "react";
import { Navigate, Route } from "react-router-dom";
import FoundingPartnerAccountingGate from "components/common/FoundingPartnerAccountingGate";
import FoundingPartnerAccountingPage from "pages/dashboard/foundingPartner/FoundingPartnerAccountingPage";

export function fusionFounderAccountingRouteElements() {
  return (
    <>
      <Route
        path="/founding-partner/accounting"
        element={<Navigate to="/dashboard/fusion-founder/accounting" replace />}
      />
      <Route
        path="/fusion-founder/accounting"
        element={
          <FoundingPartnerAccountingGate>
            <FoundingPartnerAccountingPage />
          </FoundingPartnerAccountingGate>
        }
      />
    </>
  );
}
